class FixedVideoPlayer {
  constructor() {
    this.videoPlayer = document.querySelector('[data-fixed-video]');
    this.modal = document.querySelector('[data-fixed-stories-modal]');
    
    if (this.videoPlayer && this.modal) {
      this.init();
    }
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Abrir modal ao clicar no vídeo flutuante
    this.videoPlayer.addEventListener('click', () => {
      this.openModal();
    });

    // Fechar vídeo flutuante
    const closeVideoButton = this.videoPlayer.querySelector('[data-fixed-video-close]');
    if (closeVideoButton) {
      closeVideoButton.addEventListener('click', (e) => {
        e.stopPropagation(); // Evita abrir o modal
        this.closeVideoPlayer();
      });
    }

    // Fechar modal ao clicar no overlay ou botão de fechar
    const closeElements = this.modal.querySelectorAll('[data-fixed-stories-close]');
    closeElements.forEach(element => {
      element.addEventListener('click', () => {
        this.closeModal();
      });
    });

    // Fechar modal com ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });

    // Configurar barra de progresso do vídeo
    this.setupVideoProgress();
  }

  openModal() {
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    // Iniciar vídeo com autoplay
    const video = this.modal.querySelector('.fixed-stories-modal__video');
    if (video) {
              video.play().catch(e => {});
    }
  }

  closeModal() {
    this.modal.classList.remove('active');
    document.body.style.overflow = '';
    
    // Pausar vídeo ao fechar modal
    const video = this.modal.querySelector('.fixed-stories-modal__video');
    if (video) {
      video.pause();
    }
  }

  closeVideoPlayer() {
    // Salvar no localStorage que o vídeo foi fechado
    localStorage.setItem('fixed-video-closed', 'true');
    
    // Ocultar o vídeo flutuante
    this.videoPlayer.style.display = 'none';
  }

  setupVideoProgress() {
    const video = this.modal.querySelector('.fixed-stories-modal__video');
    const progressFill = this.modal.querySelector('.fixed-stories-modal__progress-fill');
    
    if (video && progressFill) {
      // Atualizar barra de progresso
      video.addEventListener('timeupdate', () => {
        const progress = (video.currentTime / video.duration) * 100;
        progressFill.style.width = progress + '%';
      });

      // Permitir clicar na barra para navegar
      const progressBar = this.modal.querySelector('.fixed-stories-modal__progress-bar');
      if (progressBar) {
        progressBar.addEventListener('click', (e) => {
          const rect = progressBar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const clickPercent = (clickX / rect.width) * 100;
          const newTime = (clickPercent / 100) * video.duration;
          video.currentTime = newTime;
        });
      }
    }
  }
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  new FixedVideoPlayer();
});
